var render = function render(_c,_vm){return _c('transition',{attrs:{"name":"fade-scrim","appear":""}},[(_vm.props.active)?_c('div',_vm._g({ref:_vm.data.ref,staticClass:"scrim fixed inset-0 z-scrim",class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle])},_vm.listeners)):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }